package nl.volleyplanner.api.client

import io.ktor.client.*
import io.ktor.client.engine.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.auth.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.http.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.coroutines.*
import kotlinx.coroutines.flow.Flow
import kotlinx.serialization.json.Json

expect val apiEngine: HttpClientEngine

data class ApiDefaultRequestSpec(
    val apiHost: String,
    val apiPort: Int?,
    val apiProtocol: URLProtocol
) {
    fun toUrlString() : String {
        return "${apiProtocol.name}://${apiHost}${apiPort?.let { ":$it" } ?: ""}"
    }
}

open class BaseApiClient(
    private val defaultRequestSpec: ApiDefaultRequestSpec,
    private val additionalConfigBlock: (HttpClientConfig<*>.() -> Unit)?,
    private val authResetEventsFlow: Flow<Unit>? = null
) : AutoCloseable {
    private var _isClosed = false
    val isClosed
        get() = _isClosed

    private val clientScope = CoroutineScope(
        Dispatchers.Default +
            SupervisorJob() +
            CoroutineName("BaseApiClientScope") +
            CoroutineExceptionHandler { _, throwable ->
                println("Exception in BaseApiClient: $throwable")
            }
    )

    fun resetAuth() {
        httpClient.clearAuthTokens()
    }

    protected val httpClient = HttpClient(apiEngine) {
        defaultRequest {
            host = defaultRequestSpec.apiHost
            if (defaultRequestSpec.apiPort != null) {
                port = defaultRequestSpec.apiPort
            }
            url {
                protocol = defaultRequestSpec.apiProtocol
            }
        }

        expectSuccess = true

        install(ContentNegotiation) {
            json(Json {
                prettyPrint = true
            })
        }
        additionalConfigBlock?.invoke(this)
    }

    init {
        authResetEventsFlow?.let {
            clientScope.launch {
                authResetEventsFlow.collect { resetAuth() }
            }
        }
    }

    override fun close() {
        _isClosed = true
        clientScope.cancel()
        httpClient.close()
    }
}